/**
 * Initial state for the store
 * @type {{}}
 */
export const InitialState = {
    showMainNav: true
};
